import { render } from "./transInfoModel.vue?vue&type=template&id=55a7d3d8"
import script from "./transInfoModel.vue?vue&type=script&lang=js"
export * from "./transInfoModel.vue?vue&type=script&lang=js"

import "./transInfoModel.vue?vue&type=style&index=0&id=55a7d3d8&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__